import { render } from "./SpecsContainer.vue?vue&type=template&id=ee5fb82e"
import script from "./SpecsContainer.vue?vue&type=script&lang=js"
export * from "./SpecsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__